import styled from "styled-components";

import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../constants/Styles";

export const PROJECT_DETAILS_WIDTH = "328px";

export const ParentContainer = styled.div`
  width: ${PROJECT_DETAILS_WIDTH};
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const EditButton = styled.div<{ disabled: boolean }>`
  // This padding helps the edit button line up horizontally next to the placement check icons
  padding-top: 0.25rem;
  ${({ disabled }) => !disabled && `cursor: pointer;`}
  ${({ disabled }) => disabled && `filter: brightness(50%);`}
`;

export const EditableNickname = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProjectName = styled.div`
  font-weight: ${FONT_WEIGHT.weight400};
  word-break: break-word;
`;

export const DetailsCard = styled.div`
  width: 100%;
  padding: 1.5rem;
  border: 1px solid ${COLORS.tableBackground};
  border-radius: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DetailsTopLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const ChildrenContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  > button {
    width: 100%;
  }
`;

export const QuoteWarningText = styled.div<{ errored?: boolean }>`
  font-size: ${FONT_SIZE.size12};
  color: ${COLORS.secondaryLight};
  text-align: center;

  ${({ errored }) => errored && `color: ${COLORS.error}`}
`;

export const DetailLine = styled.div<{
  bottomBorder?: boolean;
  isBoardBreakdown?: boolean;
}>`
  font-size: ${FONT_SIZE.size13};
  display: flex;
  justify-content: space-between;
`;

export const QuoteOptionContainer = styled.div`
  width: 100%;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size12};
`;

export const ToolTipWrapper = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
`;

export const NumBoardsContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  font-size: ${FONT_SIZE.size16};
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
